import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import { DatePicker, Icon } from '@livable/saas-react-components';
import { Box, Button, Checkbox, ListItemText, MenuItem, Popover, Select, Typography } from '@mui/material';
import moment from 'moment';
import useStyles from './billsFilterMenuStyles';
import { BILL_STATUS_OPTIONS, EMPTY_BILL_FILTERS, hasActiveBillFilters } from './billsFilters';
const MONTH_FORMAT = 'YYYY-MM';
function FilterSelect(_ref) {
  let label = _ref.label,
    onChange = _ref.onChange,
    options = _ref.options,
    placeholder = _ref.placeholder,
    value = _ref.value;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.field
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.fieldLabel
  }, label), /*#__PURE__*/React.createElement(Select, {
    className: classes.select,
    displayEmpty: true,
    multiple: true,
    MenuProps: {
      PaperProps: {
        className: classes.optionsPaper
      }
    },
    onChange: event => onChange(event.target.value),
    renderValue: selected => selected.length ? selected.join(', ') : /*#__PURE__*/React.createElement("span", {
      className: classes.placeholder
    }, placeholder),
    size: "small",
    value: value
  }, options.length === 0 ? /*#__PURE__*/React.createElement(MenuItem, {
    disabled: true,
    value: ""
  }, "No options available") : options.map(option => /*#__PURE__*/React.createElement(MenuItem, {
    key: option,
    value: option,
    className: classes.optionItem
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: value.includes(option),
    size: "small"
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: option,
    className: classes.optionLabel
  })))));
}
export function BillsFilterMenu(_ref2) {
  let filters = _ref2.filters,
    onChange = _ref2.onChange,
    options = _ref2.options;
  const classes = useStyles();
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const handleClose = () => setAnchorEl(null);
  const setFilter = (key, value) => onChange(_objectSpread(_objectSpread({}, filters), {}, {
    [key]: value
  }));
  const servicePeriod = filters.servicePeriod ? moment(filters.servicePeriod, MONTH_FORMAT).toDate() : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    size: "small",
    className: classes.filterButton,
    "aria-controls": "bills-filter-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    onClick: event => setAnchorEl(event.currentTarget),
    startIcon: /*#__PURE__*/React.createElement(Box, {
      component: "span",
      className: classes.filterIconWrap
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "filter-new"
    }), hasActiveBillFilters(filters) && /*#__PURE__*/React.createElement("span", {
      className: classes.filterBadge
    })),
    'custom-attribute': 'bills-filters'
  }, "Filters"), /*#__PURE__*/React.createElement(Popover, {
    id: "bills-filter-menu",
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    PaperProps: {
      className: classes.panelPaper
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.panelHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    className: classes.panelTitle
  }, "Filters"), /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "small",
    className: classes.clearAllButton,
    onClick: () => onChange(EMPTY_BILL_FILTERS)
  }, "Clear all")), /*#__PURE__*/React.createElement(FilterSelect, {
    label: "Property",
    onChange: value => setFilter('properties', value),
    options: options.properties,
    placeholder: "Select property",
    value: filters.properties
  }), /*#__PURE__*/React.createElement(FilterSelect, {
    label: "Utility",
    onChange: value => setFilter('utilities', value),
    options: options.utilities,
    placeholder: "Select utility",
    value: filters.utilities
  }), /*#__PURE__*/React.createElement(Box, {
    className: classes.field
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.fieldLabel
  }, "Service period"), /*#__PURE__*/React.createElement(Box, {
    className: classes.monthField
  }, /*#__PURE__*/React.createElement(DatePicker, {
    format: "yyyy-MM",
    label: "YYYY-MM",
    onChange: date => setFilter('servicePeriod', date ? moment(date).format(MONTH_FORMAT) : ''),
    showMonthYearPicker: true,
    value: servicePeriod
  }))), /*#__PURE__*/React.createElement(FilterSelect, {
    label: "Status",
    onChange: value => setFilter('statuses', value),
    options: BILL_STATUS_OPTIONS,
    placeholder: "Select workflow stages...",
    value: filters.statuses
  }), /*#__PURE__*/React.createElement(FilterSelect, {
    label: "Provider",
    onChange: value => setFilter('providers', value),
    options: options.providers,
    placeholder: "Select provider...",
    value: filters.providers
  }), /*#__PURE__*/React.createElement(Box, {
    className: classes.panelFooter
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    size: "small",
    onClick: () => {
      onChange(EMPTY_BILL_FILTERS);
      handleClose();
    }
  }, "Clear"))));
}
export default BillsFilterMenu;